import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Paper, Box, Typography, useMediaQuery } from "@mui/material";
import axios from "axios";
import { useGroupe } from "../context/GroupeContext.js";
import ComptaItems from "../components/Compta/ComptaItems.js";
import QuotaInfo from "../components/QuotaInfo.js";

import { useAdminRole } from "../hooks/useAdminRole.js";
import { useLanguage } from "../context/LanguageContext.js";
import { logDev } from "../utils/logger.js";

const roleBannerStyle = {
  backgroundColor: "#2f2f2f",
  padding: "12px 16px",
  borderRadius: "6px",
  marginBottom: "12px",
  fontSize: "1rem",
  fontWeight: "bold",
  textAlign: "center",
  color: "#fff",
  border: "2px solid #d4af37",
  boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
  backgroundImage:
    "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)",
};

const Compta = () => {
  const { t } = useLanguage();
  const isMobile = useMediaQuery("(max-width:600px)");
  const { groupeId, nomGroupeComplet, couleur, reloadGroupeActif } = useGroupe();

  const [headerHeight, setHeaderHeight] = useState(0);
  const [bottomNavHeight, setBottomNavHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const role = useAdminRole(groupeId);
  const isAdmin = role === "admin";

  useEffect(() => {
    if (groupeId) reloadGroupeActif();
  }, [groupeId]);

  useEffect(() => {
    const header = document.querySelector('.header');
    const nav = document.querySelector('.MuiBottomNavigation-root');
    const footer = document.querySelector('.footer');

    const updateHeights = () => {
      if (header) setHeaderHeight(header.offsetHeight);
      if (nav) setBottomNavHeight(nav.offsetHeight);
      if (footer) setFooterHeight(footer.offsetHeight);
    };

  updateHeights();
  window.addEventListener("resize", updateHeights);
  return () => window.removeEventListener("resize", updateHeights);
}, []);

const topOffset = headerHeight + (isMobile ? footerHeight : bottomNavHeight) + 16;
const bottomOffset = isMobile ? bottomNavHeight : footerHeight;

if (!groupeId) return <Navigate to="/connexion" replace />;

  return (
    <Box
    className="compta-container"
      sx={{
        minHeight: "100vh",
        paddingTop: `${topOffset}px`,
        paddingBottom: `${bottomOffset}px`,
        boxSizing: "border-box",
        backgroundColor: "#f4ece2",
        overflowY: "auto"
      }} 
    >
      {isAdmin && groupeId && (
        <QuotaInfo groupeId={groupeId} isAdmin={isAdmin} />
      )}

      <Paper
        elevation={1}
        sx={{
          backgroundColor: "#f4ece2",
          width: "90vw",
          padding: 2,
          margin: "0 auto",
          maxWidth: isMobile ? "95vw" : "1200px", // 👈 limite la largeur
        }}
      >
        {/* Bannière rôle */}
        <Box sx={roleBannerStyle}>
          {isAdmin ? t("ComptaAdmin") : t("ComptaUsers")}
        </Box>

        {/* Nom du groupe */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: couleur,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1
            }}
          >
          <strong>{nomGroupeComplet}</strong>
          </Typography>

        </Box>

        {/* Tableau */}
        <ComptaItems headerHeight={headerHeight} />
      </Paper>
    </Box>
  );
};

export default Compta;
